"use client";

import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { toast } from "@/components/ui/use-toast"

interface InputWithButtonProps {
    inputValue: string;
    hexColour: string;
    textColour: string;
}
 
export function InputWithButton({ inputValue, hexColour, textColour }: InputWithButtonProps) {
    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(inputValue);
            toast({
                title: 'Value copied to clipboard'
            });
        } catch (err) {
            toast({
                title: `Failed to copy text: ${err}`,
                variant: 'destructive'
            });
        }
        
    };
  return (
    <div className="flex w-full max-w-sm items-center space-x-2">
        <Input
        id="name"
        className="shadow-md"
        size={32}
        defaultValue={inputValue}
        readOnly
        ></Input>
        <Button style={{backgroundColor: hexColour, color: textColour}} className="shadow-md" onClick={handleCopy} type="button">Copy</Button>  
      </div>
  )
}